import { SxProps, Theme } from "@mui/material/styles";

export const homeContainer: SxProps<Theme> = {
    width: {
        xs: "100%",
        md: "50%",
    },
    mx: "auto",
};
